import _ from 'lodash';
/// 车次的本地状态
export function TrainLocalEntity (sef) {
    if (!sef.local) {
        sef.local = { modified: false, expanded: false, checked: true, confirmed: false };
    }
    return sef;
};

TrainLocalEntity.touch = function (sef, { modified = false, checkpointModified = false, expanded = false, checked = false, confirmed = false } = {}) {
    sef.local = {
        /// modified: 是否有改动，跨车次调整, 加单，减单
        modified,
        /// checkpointModified: 上次检查（上次点击“确认调整”按钮调用接口）后，是否有改动
        checkpointModified,
        /// checkpointTaskNos: checkpoint 时保存的 taskNo（对应运单）
        checkpointTaskNos: sef.lineOrderResponseList.map(t => t.taskNo),
        /// expanded: 是否展开
        expanded,
        /// checked: 是否勾选
        checked,
        /// 是否已经点击 "确认调整"
        confirmed
    };
};

TrainLocalEntity.update = function (sef, dst) {
    TrainLocalEntity(sef);
    for (const key of ['modified', 'expanded', 'checked', 'confirmed']) {
        if (dst.hasOwnProperty(key)) {
            sef.local[key] = dst[key];
        }
    }
};

TrainLocalEntity.tryMarkThemModified = function (trains, indexs) {
    for (const i of indexs) {
        trains[i] && (TrainLocalEntity.tryMarkModified(trains[i]));
    }
};

/// TODO: 应该是一个计算状态: isModified
TrainLocalEntity.tryMarkModified = function (sef) {
    TrainLocalEntity(sef);
    const originTaskIds = sef.lineOrderResponseList.map(t => t.taskNo);
    const currentTaskIds = sef.tasks.map(t => t.taskNo);

    const intersection = _.intersection(originTaskIds, currentTaskIds);
    const union = _.union(originTaskIds, currentTaskIds);

    sef.local.modified = intersection.length !== union.length;

    TrainLocalEntity.tryMarkCheckpointModified(sef);
};

TrainLocalEntity.extractLocals = function (trains, omitModified = true) {
    return trains.reduce((m, t) => {
        TrainLocalEntity(t);
        const local = { ...t.local };
        if (omitModified) {
            local.modified = false;
        }
        m.set(t.trainNum, local);
        return m;
    }, new Map());
};

TrainLocalEntity.markThemConfirmed = function (trains) {
    for (const train of trains) {
        TrainLocalEntity(train).local.confirmed = true;
    }
};

TrainLocalEntity.tryMarkThemCheckpointModified = function (trains, indexs) {
    for (const i of indexs) {
        trains[i] && (TrainLocalEntity.tryMarkCheckpointModified(trains[i]));
    }
};

TrainLocalEntity.tryMarkCheckpointModified = function (sef) {
    TrainLocalEntity(sef);
    const originTaskIds = sef.checkpointTaskNos;
    const currentTaskIds = sef.tasks.map(t => t.taskNo);

    const intersection = _.intersection(originTaskIds, currentTaskIds);
    const union = _.union(originTaskIds, currentTaskIds);

    sef.local.checkpointModified = intersection.length !== union.length;
};

/// 检查点标记
TrainLocalEntity.markThemCheckpoint = function (trains) {
    for (const train of trains) {
        train.local.checkpointTaskNos = train.tasks.map(t => t.taskNo);
        train.local.checkpointModified = false;
    }
};
